// extracted by mini-css-extract-plugin
export default {"styles":"FitOnIcon_styles__3Hs9c","spin":"FitOnIcon_spin__tutmR"};